import React from 'react';
import PropTypes from 'prop-types';
import InputWithLabel from '../base/InputWithLabel/InputWithLabel';
import Picker from '../base/Picker/Picker';
import textTranslates from './translate.json';

const ChooseCompany = ({companyName, companyTax, onEditCompanyButtonClick}) => {
    return(
        <div className="col-sm-12 col-xs-12">
            <p>Uzupełnij dane firmy na podstawie numeru NIP.*</p>
            <Picker
                inputId="companyPickerInput"
                inputLabel={textTranslates.companyPickerInputLabel}
                inputValue={companyName}
                buttonId="companyPickerBtn"
                buttonText={textTranslates.companyPickerBtnText}
                onPickerButtonClick={onEditCompanyButtonClick}/>
            <div className="col-xs-12">
                <div className="col-xs-8">
                    <InputWithLabel
                        disabled
                        id="companyTaxInput"
                        label={textTranslates.companyTaxInputLabel}
                        type="text"
                        value={companyTax}/>
                </div>
            </div>
        </div>
    );
};

ChooseCompany.propTypes = {
    companyName: PropTypes.string,
    companyTax: PropTypes.string,
    onEditCompanyButtonClick: PropTypes.func
};

export default ChooseCompany;


// WEBPACK FOOTER //
// ./src/components/Customer/ChooseCompany.js